import { FunctionComponent } from "react";
import { IExternalServicesProps } from "./interfaces/IExternalServicesProps";
import { AuthorisedDevices } from "./authorised-devices/AuthorisedDevices.component";

export const ExternalServices: FunctionComponent<IExternalServicesProps> = (props) => {
    return <AuthorisedDevices model={props.model.authorisedDevices} actions={props.actions.authorisedDevices} />;
};
